/** Up-pointing send arrow glyph; uses `currentColor`. */
export type SendArrowIconProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function SendArrowIcon({ size = 24, className }: SendArrowIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 19V5M5 12l7-7 7 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SendArrowIcon;
